<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="95px">
        <el-row :gutter="24">
          <el-col span="24">
            <h4>推荐商品</h4>
          </el-col>
          <el-col span="24">
            <el-button type="primary" @click="addGoods()" size="small">添加</el-button>
            <div style="margin-top: 10px"></div>
            <el-table :data="tableData" border style="width: 100%" height="500">
              <el-table-column label="序号" type="index" width="100" align="center">
              </el-table-column>
              <el-table-column prop="name" label="商品名" width="180" align="center">
              </el-table-column>
              <el-table-column prop="icon" label="图片" width="200" align="center">
                <template slot-scope="scope">
                  <el-image
                    style="width: 120px; height: 120px"
                    :src="scope.row.icon"
                    :preview-src-list="[scope.row.icon]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="introduce" label="商品介绍" align="center"> </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="editGoods(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="deleteGoods(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div style="text-align: right">
              <el-pagination background layout="prev, pager, next" :total="tableData.length">
              </el-pagination>
            </div> -->
          </el-col>
        </el-row>
      </el-form>
      <!-- 添加按钮弹窗 -->
      <hr-dialog
        :title="formModel === 'add' ? '新增' : formModel === 'edit' ? '编辑' : '删除'"
        :allowFull="false"
        width="60%"
        :visible.sync="addGoodsVisible"
      >
        <template slot="body">
          <addGoodsForm
            :id="row.id"
            :model="formModel"
            :row="formRow"
            @cancle="recordCancle"
            @submit="getGoods"
            v-if="addGoodsVisible"
          ></addGoodsForm>
        </template>
      </hr-dialog>
    </div>
    <!-- <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div> -->
  </div>
</template>
<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/offline/merchant/goods/offlinemerchantgoods';
import addGoodsForm from './addGoodsForm.vue';
import { getDictionary } from '@/api/common.js';
export default {
  components: {
    addGoodsForm,
  },
  props: {
    row: {
      default: {},
    },
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      formModel: {},
      formRow: {},
      addGoodsVisible: false,
      tableData: [
      ],
      sexList: [],
      projectList: [],
      choiceUserVisible: false,
      form: {
        name: '',
        icon: '',
        introduce: '',
      },
      formRules: {
        name: [{ required: true, message: '商品名不能为空', trigger: 'change' }],
        introduce: [{ required: true, message: '商品介绍不能为空', trigger: 'change' }],
        attachList: [{ required: true, message: '商品图片不能为空', trigger: 'change' }],
      },
    };
  },
  created() {
    console.log(this.model);
    console.log(this.row);
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    //编辑商品
    editGoods(row) {
      this.formModel = 'edit';
      this.formRow = row;
      this.addGoodsVisible = true;
    },
    //删除商品
    deleteGoods(scope) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.formModel = 'delete';
          console.log(scope);
          //调取删除接口
          return remove({ ids: scope.row.id });
        })
        .then(() => {
          this.getGoodsTable()
          this.$message.success('删除成功!');
        });
    },
    //添加商品
    addGoods() {
      this.formModel = 'add';
      this.addGoodsVisible = true;
    },
    choiceUser() {
      console.log('--');
      this.choiceUserVisible = true;
    },
   
    async initData() {     
     this.getGoodsTable()
    },
    //获取后端列表接口getList
    getGoodsTable(){
      getList({merchantId:this.row.id}).then(res=>{
        this.tableData = res.data
      })
    },
    getGoods(data) {
      // console.log(data);
      // this.tableData.push(data);
      this.getGoodsTable()
      this.addGoodsVisible = false;
    },
    recordCancle(){
      this.addGoodsVisible = false;
    },
    saveRecord() {
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            smartcardsave(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            stockWarnUpdate(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
